import { httpVerbs, } from '../types/index.js';
import { resolveConfig } from '../utils/index.js';
const jsonHeaders = {
    Accept: 'application/json',
    'Content-Type': 'application/json',
};
export const fetchClient = (configSource = {}) => {
    const request = (verb) => async (url, request = {}) => {
        const config = await resolveConfig(configSource);
        return fetch(`${config.baseUrl ?? ''}${url}`, {
            method: verb?.toUpperCase(),
            headers: {
                ...config.headers,
                ...request.headers,
                ...(request.json ? jsonHeaders : {}),
            },
            body: request.json ? JSON.stringify(request.json) : request.body,
            signal: request.signal,
        });
    };
    return {
        ...Object.fromEntries(httpVerbs.map((verb) => [verb, request(verb.toUpperCase())])),
        request,
        getConfig: () => Promise.resolve(resolveConfig(configSource)),
    };
};
